import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var CalendarMarkSvg = function CalendarMarkSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.519 13.284h2.777v-1.468H5.52zM8.296 17.872H5.52v-1.468h2.777zM10.611 13.284h2.778v-1.468H10.61zM18.482 13.284h-2.778v-1.468h2.778zM10.611 17.872h2.778v-1.468H10.61z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.889 4.018H8.11V2H6.63v2.018H2V22h20V4.018h-4.63V2H15.89zM3.48 5.486v2.202h17.037V5.486zm0 15.046V9.156h17.037v11.376z",
    clipRule: "evenodd"
  }));
};
export var CalendarMark = function CalendarMark(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: CalendarMarkSvg
  }));
};